import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { BODY_NO_PADDING } from 'enum/helpers';
import TrackedRoute from 'overwrites/TrackedRoute';


export default class HeadlessLayout extends Component {
  static propTypes = {
    Page: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    path: PropTypes.string.isRequired,
    exact: PropTypes.bool,
  };

  static defaultProps = { exact: false };

  componentDidMount() {
    const bodyElem = document.querySelector('body');
    bodyElem.classList.add(BODY_NO_PADDING);
  }

  componentWillUnmount() {
    const bodyElem = document.querySelector('body');
    bodyElem.classList.remove(BODY_NO_PADDING);
  }

  renderPage = ({ match }) => {
    const { Page, path, exact, ...props } = this.props;

    return <Page {...props} match={match} />;
  };

  render() {
    const { path, exact } = this.props;

    return <TrackedRoute exact={exact} path={path} render={this.renderPage} />;
  }
}
